import { getEnv as mobxEasyGetEnv } from "mobx-easy";
import { RootEnv } from "./create-store";

export const getEnv = (): RootEnv => mobxEasyGetEnv<RootEnv>();
